export default __webpack_public_path__ + "static/media/mockup_newsletter.297bbf02.png";